import React from "react";
import CryptoTradingDemo from "./components/CryptoTradingDemo";
import "./styles/globals.css";

function App() {
  return (
    <div className="App">
      <CryptoTradingDemo />
    </div>
  );
}

export default App;
